import styled from 'styled-components/macro'

export const Stepper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin: 8px 0 24px;

  button {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 1px solid ${props => props.theme.border};
    background: ${props => props.theme.inputBackground};
    color: ${props => props.theme.normalText};
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, opacity 0.2s ease;
  }

  button:hover:not(:disabled) {
    background: ${props => props.theme.accentForHover};
  }

  button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const PriceDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;

  .level {
    font-size: 14px;
    font-weight: 600;
    color: ${props => props.theme.mutedText};
  }

  .price {
    font-size: 28px;
    font-weight: 700;
    color: ${props => props.theme.normalText};
  }
`

export const PreviewWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const EmailPreview = styled.pre`
  margin: 0;
  padding: 16px;
  padding-bottom: 52px;
  border-radius: 12px;
  background: ${props => props.theme.inputBackground};
  border: 1px solid ${props => props.theme.border};
  color: ${props => props.theme.normalText};
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`

export const CopyButton = styled.button`
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid ${props => props.theme.border};
  background: ${props => props.theme.white};
  color: ${props => props.theme.mutedText};
  font-size: 15px;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${props => props.theme.accent};
    border-color: ${props => props.theme.accent};
  }

  &.copied {
    color: ${props => props.theme.green};
    border-color: ${props => props.theme.green};
  }
`
